// extracted by mini-css-extract-plugin
export var errorsContainer = "_ub-1";
export var link = "_ub-0";